import React, { useContext, useEffect } from 'react'
import { AppContext } from 'stores/AppStore'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'
import { FlexView, LoadingOverlay } from 'components/common'
import { useHistory } from 'react-router-dom'
import { TransportContext } from 'stores/ManagementTransportStore'
import { FaArrowRight } from 'react-icons/fa'
import FilteredTable, { SelectColumnFilter } from 'components/common/FilteredTable'
import moment from 'moment'

const Transport = () => {
  const { t } = useTranslation()
  const { registryLog, currentUser } = useContext(UserContext)
  const { setPageSubtitle } = useContext(AppContext)
  const { transportSearch, getSearchTransport, setSolicitacao, loading } = useContext(TransportContext)
  const history = useHistory()
  const DEFAULT_URL = "management-transport"

  useEffect(() => {
    registryLog('client_in', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'navigation', 'page_in')
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageSubtitle(t('transport.pageTitle'))
    getSearchTransport()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setPageSubtitle, t])

  const goTo = async (row) => {
    setSolicitacao(row.solicitacao)
    window.localStorage.setItem('id', row.id)
    window.localStorage.setItem('solicitacao', row.solicitacao)
    history.push("/management-transport/information")
  }

  const columns = [
    {
      Header: t('transport.requestNumber'),
      accessor: (row) => row.solicitacao,
      id: "requestNumber",
    },
    {
      Header: t('transport.mapNumber'),
      accessor: (row) => row.mapa || t('transport.pending'),
      id: "mapNumber",
    },
    {
      Header: t('transport.status.status'),
      accessor: (row) => t(`transport.status.${row.status}`),
      id: "status",
      Filter: SelectColumnFilter
    },
    {
      Header: t('transport.origin'),
      accessor: (row) => row.origin,
      id: "origin",
    },
    {
      Header: t('transport.destination'),
      accessor: (row) => row.destination,
      id: "destination",
    },
    {
      Header: t('transport.scheduledDate'),
      accessor: (row) => moment(row.scheduledDate).utc().format('L'),
      id: "scheduledDate",
    },
    {
      Header: t("transport.details"),
      accessor: (row) => <FaArrowRight title={t("transport.details")} style={{ cursor: 'pointer' }} size={16} color='#777' onClick={() => goTo(row)} />,
      id: "details",
      disableFilters: true,
    },
  ]

  if (currentUser.roles.VSM_SUPPLIER.VSM_SUPPLIER_TRANSPORT_ADM) {
    columns.splice(2, 0, {
      Header: t('transport.shippingCompany'),
      accessor: (row) => row.shippingCompany,
      id: "shippingCompany",
      Filter: SelectColumnFilter
    },)
  }

  if (loading) return (
    <LoadingOverlay visible={loading} />
  )

  return <FlexView
    alignSelf="stretch"
    alignItems="center"
    flex='1'
    backgroundColor="background"
    padding="16px"
  >
    <FilteredTable width="100%" columns={columns} data={transportSearch} style={{ whiteSpace: 'nowrap', textAlign: 'center' }} />
  </FlexView>
}
export default Transport
